import { Component, OnInit, OnDestroy, ViewEncapsulation, HostListener, Input, NgZone } from '@angular/core';
import { finalize, delay } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { untilDestroyed } from 'src/app/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AnalyticsService } from './analytics.service';
import { Main } from 'src/app/core/main.service';
import * as FusionCharts from 'fusioncharts';
import { environment } from '@env/environment';

@Component({
  selector: 'app-ekub-analytics',
  templateUrl: './ekub.analytics.component.html',
  styleUrls: ['./ekub.analytics.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EkubAnalyticsComponent implements OnInit, OnDestroy {
  title: string;
  dataSource: any;
  id: string;
  pieDataSource: any;
  ekub: any;
  ekubAnalytics: any = {
    total_balance: 0,
    balance_due: 0,
    total_members: 0,
    active_members: 0,
    qualified_members: 0,
    disqualified_members: 0,
    //lagging_percentage: 0,
    total_sales: {
      count: 0,
      value: 0
    },
    pending_sales: {
      count: 0,
      value: 0
    },
    awards_granted: {
      count: 0,
      value: 0
    },
    awards_pending: {
      count: 0,
      value: 0
    },
    recent_transactions: [],
    recent_awards: [],
    recent_sales: [],
    members: []
  };
  chartConfig: Object;
  dataSource2: any;
  chartConfig2: Object;
  baseUrl: string = environment.production
    ? environment.ONLINE_BASE_URL :
    environment.LOCAL_BASE_URL;

  laggingEkubs: any = [
    {
      ekubID: 'EK-124123',
      draw_date: 'Jan 10, 2021',
      status: 'active',
      amountLagged: 120000,
    }, {
      ekubID: 'EK-244123',
      draw_date: 'Jan 10, 2021',
      status: 450000
    },
    {
      ekubID: 'EK-454123',
      draw_date: 'Jan 10, 2021',
      status: 510000
    }
  ];


  constructor(private router: Router, private route: ActivatedRoute,
    private api: AnalyticsService, private mainService: Main) {
    this.id = this.route.params['value']['id'];
    this.chartConfig2 = {
      /*   width: '700',
        height: '400', */
      width: '100%',
      height: '585',
      type: 'column2d',
      dataFormat: 'json',
      palettecolors: "FFE4B5",
    };

    this.dataSource2 = {
      "chart": {
        "caption": "Transactions Statistics for the Current Year",
        "subCaption": "the higher the better",
        "xAxisName": "Month",
        "yAxisName": "Transactions (in ETB)",
        //"numberSuffix": " ETB",
        "theme": "fusion",
        "palettecolors": "#AB6B51"
      },
      data: []
    };


    this.pieDataSource = {
      chart: {
        "caption": "Ekub Health: EK-972343",
        //"plottooltext": "<b>$percentValue</b> of ekubs $label servers",
        "showLegend": "1",
        "showPercentValues": "1",
        "legendPosition": "bottom",
        "useDataPlotColorForLabels": "1",
        "enablemultislicing": "0",
        "showlegend": "0",
        "theme": "fusion",
        "canvasPadding": "0",
        "chartLeftMargin": "-70",
        width: '100%',
        height: '585',

      },
      data: []
    };

    this.chartConfig = {
      type: 'doughnut2d',
      width: '550',
      height: '400',
      //palettecolors: "FFE4B5",
    };
    /* this.type = 'timeseries';
    this.width = '100%';
    this.height = '585'; */
    // This is the dataSource of the chart
    this.dataSource = {
      // Initially data is set as null
      chart: {
        showLegend: 1,
      },
      data: null,
      caption: {
        text: ''
      },
      subcaption: {
        text: 'since 2015'
      },
      yAxis: [
        {
          plot: [
            {
              value: 'Total Users',
              type: 'column'
            },
            {
              value: 'Active Users',
              type: 'line'
            }
          ]
        }
      ]
    };
    this.getEkubAnalytics();
    this.getEkub();
  }

  ngOnInit() {
    let init = localStorage.getItem('init');
    if (init) {
      localStorage.removeItem('init');
      location.reload();
    }
  }

  getEkub() {
    this.api.getEkub(this.id).subscribe((res: any) => {
      //this.isLoading = !this.isLoading;
      debugger;
      this.ekub = res.data;
      switch (this.ekub.category.data.interval) {
        case 'weekly':
          this.ekub.category.data.interval_name = 'weeks';
          break;
        case 'monthly':
          this.ekub.category.data.interval_name = 'months';
          break;
        case 'daily':
          this.ekub.category.data.interval_name = 'days';
          break;
      }
    }, (err) => {
      err = err;
      //this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: 'Error fetching ekub!', type: 'danger' });
    });
  }


  getEkubAnalytics() {
    this.api.getEkubAnalytics(this.id, '').subscribe((res: any) => {
      //this.isLoading = !this.isLoading;
      this.ekubAnalytics = res.data;
      this.pieDataSource.data.push({
        "label": "Total Balance",
        "value": this.ekubAnalytics.total_balance,
        "color": "#00A300"
      });
      this.pieDataSource.data.push({
        "label": "Balance Due",
        //"value": this.ekubAnalytics.balance_due,
        "value": this.ekubAnalytics.difference,
        "color": "#DC143C"
      });

      for (let transaction of this.ekubAnalytics.transactions) {
        this.dataSource2.data.push({
          "label": transaction.month,
          "value": transaction.total_transactions_value,
          //"color": "#DC143C"
        });
      }

    }, (err) => {
      err = err;
      //this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Error', body: 'Error fetching ekub analytics!', type: 'danger' });
    });
  }

  ngOnDestroy(): void {

  }

}
